"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchCollectionByShopId = exports.fetchCollection = exports.fetchShopStatusByShopId = exports.fetchShop = exports.fetchShopByShopId = exports.fetchShopWhitelistNftByShopId = void 0;
const qs_1 = __importDefault(require("qs"));
const constants_1 = require("../constants");
const Logger = 'CandyShopSDK/ShopAPI';
async function fetchShopWhitelistNftByShopId(axiosInstance, shopId) {
    console.log(`${Logger}: fetching shop whitelist nft`);
    const url = `/shop/wlNfts/${shopId}`;
    return axiosInstance.get(url).then((response) => response.data);
}
exports.fetchShopWhitelistNftByShopId = fetchShopWhitelistNftByShopId;
async function fetchShopByShopId(axiosInstance, shopId) {
    const url = `/shop/id/${shopId}`;
    return axiosInstance.get(url).then((response) => response.data);
}
exports.fetchShopByShopId = fetchShopByShopId;
async function fetchShop(axiosInstance, shopQuery) {
    console.log(`${Logger}: fetching shop, query=`, shopQuery);
    const { offset, limit = constants_1.FETCH_LIST_LIMIT, name } = shopQuery || {};
    let queryObject = {};
    if (offset) {
        queryObject = { offset, limit };
    }
    if (name && typeof name === 'string') {
        queryObject.name = name;
    }
    const queryString = qs_1.default.stringify(queryObject);
    const url = `/shop?${queryString}`;
    return axiosInstance.get(url).then((res) => res.data);
}
exports.fetchShop = fetchShop;
async function fetchShopStatusByShopId(axiosInstance, shopId, query) {
    const { targets, walletAddress } = query;
    const queryString = qs_1.default.stringify({ walletAddress, targets }, { indices: false });
    const url = `/status/${shopId}?${queryString}`;
    return axiosInstance.get(url).then((res) => res.data);
}
exports.fetchShopStatusByShopId = fetchShopStatusByShopId;
async function fetchCollection(axiosInstance, collectionQuery) {
    console.log(`${Logger}: fetching NFT Collection, query=`, collectionQuery);
    const { offset, limit = constants_1.FETCH_LIST_LIMIT, name } = collectionQuery || {};
    let queryObject = {};
    if (offset !== undefined) {
        queryObject = { offset, limit };
    }
    if (name && typeof name === 'string') {
        queryObject.name = name;
    }
    const queryString = qs_1.default.stringify(queryObject);
    return await axiosInstance
        .get(`/nftCollection?${queryString}`)
        .then((response) => response.data);
}
exports.fetchCollection = fetchCollection;
async function fetchCollectionByShopId(axiosInstance, collectionQuery) {
    const { shopId, offset, limit = constants_1.FETCH_LIST_LIMIT, name } = collectionQuery || {};
    let queryObject = {};
    if (offset !== undefined) {
        queryObject = { offset, limit };
    }
    if (name && typeof name === 'string') {
        queryObject.name = name;
    }
    const queryString = qs_1.default.stringify(queryObject);
    console.log(`${Logger}: fetching NFT Collection by ShopId`, collectionQuery);
    return await axiosInstance
        .get(`/nftCollection/${shopId}?${queryString}`)
        .then((response) => response.data);
}
exports.fetchCollectionByShopId = fetchCollectionByShopId;
